import { Box, Container, Grid, Typography, Card, CardContent, Stack, useTheme, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import Seo from '../components/Seo';

const AboutHeader = () => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        bgcolor: theme.palette.background.default,
        pt: { xs: 10, md: 12 },
        pb: { xs: 6, md: 8 },
        textAlign: 'center',
      }}
    >
      <Container>
        <Typography variant="h1" component="h1" sx={{ mb: 2 }}>
          About SOLVENDA
        </Typography>
        <Typography variant="subtitle1" sx={{ maxWidth: 800, mx: 'auto', mb: 4, color: theme.palette.text.secondary }}>
          Learn more about our mission and the team behind SOLVENDA
        </Typography>
      </Container>
    </Box>
  );
};

const AboutContent = () => {
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        py: 8,
        bgcolor: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#ffffff',
      }}
    >
      <Container>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Typography variant="h3" component="h2" gutterBottom>
              Our Mission
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: theme.palette.text.secondary }}>
            SOLVENDA was created with a clear mission: to help Internet Service Providers in Albania with cutting-edge management tools that simplify operations and enhance profitability.            </Typography>
            <Typography variant="body1" paragraph sx={{ color: theme.palette.text.secondary }}>
            We identified a gap in the market for comprehensive ISP management solutions specifically tailored to the needs and challenges of Albanian ISPs. With years of experience in the telecommunications industry, we designed SOLVENDA to address these unique requirements.            </Typography>
            <Typography variant="body1" paragraph sx={{ color: theme.palette.text.secondary }}>
            Our software combines powerful features with intuitive design, making it accessible for ISPs of all sizes—from small local providers to larger regional operations.            </Typography>
          </Grid>
          {/* <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/images/about-us.jpg"
              alt="SOLVENDA Team"
              sx={{
                width: '100%',
                height: 'auto',
                borderRadius: 2,
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              }}
            />
          </Grid> */}
        </Grid>

        <Box sx={{ mt: 10 }}>
          <Typography variant="h3" component="h2" gutterBottom align="center">
            Why Choose SOLVENDA
          </Typography>
          <Typography variant="body1" paragraph align="center" sx={{ mb: 6, color: theme.palette.text.secondary, maxWidth: '800px', mx: 'auto' }}>
            SOLVENDA stands out as the premier choice for ISP management in Albania for several key reasons:
          </Typography>
          
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ 
                height: '100%',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
                }
              }}>
                <CardContent>
                  <Typography variant="h6" align="center" gutterBottom fontWeight="bold" color="primary">
                    Local Expertise
                  </Typography>
                  <Typography variant="body2" align="center">
                    Designed with deep understanding of regional ISP operations
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ 
                height: '100%',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
                }
              }}>
                <CardContent>
                  <Typography variant="h6" align="center" gutterBottom fontWeight="bold" color="primary">
                    Complete Solution
                  </Typography>
                  <Typography variant="body2" align="center">
                    All-in-one platform for customer, service, and financial management
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ 
                height: '100%',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
                }
              }}>
                <CardContent>
                  <Typography variant="h6" align="center" gutterBottom fontWeight="bold" color="primary">
                    Customizable
                  </Typography>
                  <Typography variant="body2" align="center">
                    Easily adapts to your unique business workflows
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ 
                height: '100%',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
                }
              }}>
                <CardContent>
                  <Typography variant="h6" align="center" gutterBottom fontWeight="bold" color="primary">
                    Affordable
                  </Typography>
                  <Typography variant="body2" align="center">
                    Cost-effective solution with transparent pricing
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

const TeamSection = () => {
  const theme = useTheme();
  
  const team = [
    {
      name: 'Fabio Marku',
      role: 'Software Engineer',
      bio: 'As the driving force behind SOLVENDA, Fabio brings exceptional expertise in software development and system architecture. His vision and technical leadership have been fundamental to creating a powerful, scalable solution that perfectly meets the unique needs of Albanian ISPs. Fabio innovative approach ensures that SOLVENDA remains at the cutting edge of ISP management technology.',
      image: '/images/team/fabio.jpg',
      linkedin: 'https://linkedin.com/in/fabiomarku',
      phone: '+355 69 654 6099',
    //  whatsapp: 'https://wa.me/355696546099',
      email: 'fabiomarku@solvenda.org'
    },
    {
      name: 'Fatmir Brihmani',
      role: 'Network Engineer',
      bio: 'Fatmir contributes valuable network engineering expertise to the SOLVENDA team. His practical understanding of ISP infrastructure and operations in Albania has helped shape the solutions networking capabilities, ensuring seamless integration with various service platforms and optimal performance across different network environments.',
      image: '/images/team/fatmir.jpg',
      linkedin: 'https://www.linkedin.com/in/fatmir-brihmani-ab97a0158/',
      phone: '+355 68 570 5551',
    //  whatsapp: 'https://wa.me/355685705551',
      email: 'fatmirbrihmani@solvenda.org'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 10 }}>
      <Typography 
        variant="h2" 
        component="h2" 
        align="center" 
        gutterBottom
        sx={{ mb: 6, fontWeight: 'bold' }}
      >
        Meet Our Team
      </Typography>
      <Grid container spacing={4}>
        {team.map((member, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 2,
                overflow: 'hidden',
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: '0 15px 30px rgba(0,0,0,0.1)',
                }
              }}
            >
              {/* <CardMedia
                component="img"
                height={400}
                //image={member.image}
                alt={member.name}
                sx={{ objectFit: 'cover' }}
              /> */}
              <CardContent sx={{ flexGrow: 1, p: 3 }}>
                <Typography variant="h4" component="h3" gutterBottom>
                  {member.name}
                </Typography>
                <Typography variant="subtitle1" color="primary" gutterBottom sx={{ fontWeight: 'bold' }}>
                  {member.role}
                </Typography>
                <Typography variant="body1" paragraph>
                  {member.bio}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                  <IconButton
                    component="a"
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#0077B5',
                      '&:hover': { backgroundColor: 'rgba(0, 119, 181, 0.1)' }
                    }}
                  >
                    <LinkedInIcon />
                  </IconButton>
                  <IconButton
                    component="a"
                    href={`tel:${member.phone.replace(/\s+/g, '')}`}
                    sx={{ 
                      color: theme.palette.success.main,
                      '&:hover': { backgroundColor: `${theme.palette.success.main}0f` }
                    }}
                  >
                    <PhoneIcon />
                  </IconButton>
                  {/* <IconButton
                    component="a"
                    href={member.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ 
                      color: '#25D366',
                      '&:hover': { backgroundColor: 'rgba(37, 211, 102, 0.1)' }
                    }}
                  >
                    <WhatsAppIcon />
                  </IconButton> */}
                  <IconButton
                    component="a"
                    href={`mailto:${member.email}`}
                    sx={{ 
                      color: theme.palette.primary.main,
                      '&:hover': { backgroundColor: `${theme.palette.primary.main}0f` }
                    }}
                  >
                    <EmailIcon />
                  </IconButton>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

const AboutPage = () => {
  return (
    <div>
      <Seo
        title="About SOLVENDA | Leading ISP Management Solution in Albania"
        description="Learn about SOLVENDA, the innovative ISP management platform developed specifically for Internet Service Providers in Albania and the Balkans. Discover our story, mission and values."
        keywords="SOLVENDA company, ISP management Albania, Albanian ISP solution, ISP software Balkans, telecom solution Albania"
        path="/about"
      />
      <Box>
        <AboutHeader />
        <AboutContent />
        <TeamSection />
      </Box>
    </div>
  );
};

export default AboutPage; 